import React from "react";

import { Modal } from "@shared/components";
import { useTranslate } from "@refinedev/core";

import { CodeForm } from "../CodeForm";
import { EditCodeModalProps } from "./types";
import { useEditCodeModal } from "./controller";

export const EditCodeModal = React.memo(({ modalRef, onComplete }: EditCodeModalProps) => {
  const translate = useTranslate();

  const { methods, handleSubmit, isPending } = useEditCodeModal(modalRef, onComplete);

  return (
    <Modal
      ref={modalRef}
      title={translate("limited_code_admin.titles.edit")}
      onConfirm={handleSubmit}
      methods={methods}
      isPending={isPending}
    >
      <CodeForm />
    </Modal>
  );
});
